<template>
  <div>
    <div class="hero hero-cover hero-gradient">
      <div class="container">
        <h1 class="text-white text-center">O nama</h1>
      </div>
    </div>

    <div class="section push-content bg-white text-secondary">
      <div class="container">
        <p class="font-light text-justify" v-scroll-reveal>
          Implementiranjem najnovijih globalnih rješenja i njihovim
          prilagođavanjem konkretnim situacijama i potrebama, tvrtka Supra Net
          se u kratkom vremenu razvila u jednu od vodećih tvrtki u regiji u
          segment projektiranja, implementacije i razvoja zahtjevnih
          elektroenergetskih i EKMI rješenja.
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          Svojim korisnicima nudimo najnovije usluge i tehnologije kroz
          partnerstva s vodećim svjetskim proizvođačima telekomunikacijske i
          elektroenergetske opreme, kontinuirano pratimo najnovije trendove na
          tržištu te ih implementiramo u svoje poslovanje. Konstantno radimo na
          inovacijama i poboljšanjima procesa što nam omogućava realizaciju
          velikih projekata u ugovorenim rokovima uz korištenje kvalitetne
          opreme i najsuvremenijih alata te mjernih instrumenata.
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          Smatramo da su za naš uspjeh najzaslužniji naši zaposlenici, stoga im
          osiguravamo ostvarenje punog profesionalnog potencijala kroz stalno
          obrazovanje i usavršavanje te mogućnost napredovanja. Profesionalizam,
          odgovornost i entuzijazam svakog od nas implementiramo u uspješno
          realizirane projekte na zadovoljstvo korisnika.
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          Tvrtka je članica STORM Grupe, koja je na hrvatskom i regionalnom
          tržištu, prepoznata kao vodeći sistem integrator. Nastupajući na
          tržištu, zajedno s ostalim članicama Grupe, nudimo zaokruženu i
          potpunu uslugu po principu „ključ u ruke“ prepoznajući inovativne
          potrebe i specifične zahtjeve poslovnih partnera i korisnika.
        </p>
      </div>
    </div>

    <div class="section bg-gray-100">
      <div class="container _xl pull-content">
        <figure
          class="bg-cover w-full h-64 md:h-96 xl:h-128 mx-auto max-w-2xl xxl:max-w-3xl fhd:max-w-4xl"
          style="background-image: url('/img/about/about-1.jpg')"
          v-scroll-reveal
        ></figure>
      </div>
    </div>

    <div class="section push-content pt-0 bg-gray-100 text-secondary">
      <div class="container">
        <h2 class="text-4xl lg:text-5xl" v-scroll-reveal>
          Supra Net kroz godine
        </h2>
        <span class="block w-3/4 sm:w-32 h-px bg-gray-200 my-6 lg:my-12"></span>
        <p class="font-light text-justify" v-scroll-reveal>
          Tijekom 20 godina poslovanja, tvrtka usavršava i razvija rješenja u
          području telekomunikacijskih i elektroenergetskih mreža. Prateći
          trendove i zahtjeve tržišta svoje poslovanje uspješno širimo i na
          mobilne telekomunikacijske stanice te optičku mrežnu infrastrukturu.
          Usmjerenost tvrtke ka inovacijama i dugogodišnje iskustvo na razvoju
          rješenja prema specifičnim potrebama korisnika rezultiralo je
          stvaranjem SupraControl sustava koji omogućuje kontrolu pristupa i
          nadzor uvjeta rada u telekomunikacijskim i poslužiteljskim ormarima.
          Svojim odnosom prema zaposlenicima, kontinuiranim obrazovanjem i
          usavršavanjem, tvrtka potiče stvaranje što kvalitetnijeg kadra dok
          širenjem poslovanja i otvaranjem novih radnih mjesta te zdravom
          konkurencijom prema srodnim tvrtkama, tvrtka potiče razvoj tržišta te
          uspostavlja pozitivne odnose s društvom u cjelini.
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          2004 Osnovana tvrtka s ciljem distribucije pasivne opreme za
          strukturno kabliranje
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          2005 Pokrenut odjel za instalacije svjetlovodne infrastrukturne mreže
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          2007 Pokrenut razvojni odjel TIMgis aplikacija
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          2008 Pokrenut odjel za elektro instalacije
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          2011 Pokrenut razvoj SupraControl sustava
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          2021 Pokrenut odjel za fotonaponske elektrane „SupraSolar“
        </p>
        <p class="font-light text-justify" v-scroll-reveal>
          2024 Tvrtka obilježila 20 godina uspješnog poslovanja
        </p>
      </div>
    </div>

    <div class="section">
      <div class="container _xl pull-content">
        <figure
          class="bg-cover w-full h-64 md:h-96 xl:h-128 mx-auto max-w-2xl xxl:max-w-3xl fhd:max-w-4xl"
          style="background-image: url('/img/about/supranet-onama-img2.jpg')"
          v-scroll-reveal
        ></figure>
      </div>
    </div>

    <div class="section push-content pt-0">
      <div class="container" v-scroll-reveal>
        <h2 class="text-4xl lg:text-5xl">Supra Net danas</h2>
        <span class="block w-3/4 sm:w-32 h-px bg-gray-200 my-6 lg:my-12"></span>
        <p class="font-light text-justify">
          Tvrtka Supra Net je kroz godine izrasla u tvrtku sa preko 66 stalno
          zaposlenih i sa gotovo 20 kooperanata i manjih partnerskih tvrtki.
          Danas možemo odgovoriti na najrazličitije zahtjeve koje korisnici
          stavljaju pred nas - od projektiranja, preko realizacije pa sve do
          dokumentiranja izvedenog stanja na svim područjima naših djelatnosti.
          U našoj referentnoj listi nalaze se mnoga zvučna imena hrvatskog
          gospodarstva, te nas ujedno ta lista i obvezuje na daljnji napredak te
          stručno i profesionalno realiziranje budućih projekata.
        </p>
      </div>

      <div class="container">
        <div
          class="flex flex-wrap text-center sm:text-left italic my-8 md:my-12 xl:my-16 xxl:my-24"
          v-scroll-reveal.reset="{
            beforeReveal: allowCounting,
            afterReset: resetCounter,
          }"
        >
          <div class="w-full sm:w-1/3 has-hover-effect">
            <span
              class="block w-24 mx-auto sm:mx-0 sm:w-32 h-px bg-gray-900"
            ></span>
            <animated-number
              :number="counter1.number"
              :allowCounting="this.allowCountingFlag"
            ></animated-number>
            <p
              class="text-center sm:text-left font-light"
              v-text="counter1.title"
            ></p>
          </div>
          <div class="w-full sm:w-1/3 mt-6 sm:mt-0 has-hover-effect">
            <span
              class="block w-24 mx-auto sm:mx-0 sm:w-32 h-px bg-gray-900"
            ></span>
            <animated-number
              :number="counter2.number"
              :allowCounting="this.allowCountingFlag"
            ></animated-number>
            <p
              class="text-center sm:text-left font-light"
              v-text="counter2.title"
            ></p>
          </div>
          <div class="w-full sm:w-1/3 mt-6 sm:mt-0 has-hover-effect">
            <span
              class="block w-24 mx-auto sm:mx-0 sm:w-32 h-px bg-gray-900"
            ></span>
            <animated-number
              :number="counter3.number"
              :allowCounting="this.allowCountingFlag"
            ></animated-number>
            <p
              class="text-center sm:text-left font-light"
              v-text="counter3.title"
            ></p>
          </div>
        </div>

        <div v-scroll-reveal>
          <h2 class="text-4xl lg:text-5xl">Standardi poslovanja</h2>
          <span
            class="block w-3/4 sm:w-32 h-px bg-gray-200 my-6 lg:my-12"
          ></span>
          <p class="font-light text-justify">
            Definiranjem politika sustava upravljanja tvrtka Supra Net se
            opredijelila za sustavno i učinkovito upravljanje kvalitetom i
            sigurnošću svojih proizvoda i usluga.
          </p>
          <p class="font-light text-justify">
            Sustavi upravljanja omogućavaju nam ispunjenje zakonskih obveza i
            osiguravaju dokaze da je poslovanje naše tvrtke usklađeno s
            upravljačkim postupcima koje propisuju europske ETSI i CEN norme i
            koji su kao najbolja praksa iskazani međunarodnim normama ISO 9001 I
            ISO/IEC 27001
          </p>
          <p class="font-light text-justify">
            Sustav upravljanja kvalitetom temelji se na načelima usmjerenosti
            prema zadovoljenju zahtjeva kupaca, na kontinuiranom poboljšavanju
            procesa i na razvoj partnerskih odnosa, osiguravajući tako
            kvalitetan proizvod i uslugu.
          </p>
          <p class="font-light text-justify">
            Sustav upravljanja informacijskom sigurnošću potpuno je posvećen
            zaštiti povjerljivosti svih podataka, integriteta i raspoloživosti
            cjelokupne materijalne i nematerijalne imovine, a u cilju
            unaprjeđenja sigurnosti poslovanja, očuvanja ugleda te održanja
            konkurentske prednosti.
          </p>
          <p class="font-light text-justify">
            Proizvodi i usluge naše tvrtke podvrgnuti su neovisnim ispitivanjima
            i ocjenjivanjima kako bi dokazali kvalitetu i sigurnost, te tako
            pomogli ostvarenju vizije razvoja našeg poslovanja u Republici
            Hrvatskoj.
          </p>
          <p class="font-light text-justify">
            Stjecanje partnerskih statusa s vodećim svjetskim proizvođačima
            telekomunikacijske opreme te certifikacija tvrtke prema ISO
            standardima omogućavaju djelovanje tvrtke u skladu s međunarodnim i
            lokalnim standardima, što korisnicima pruža najširi spektar usluga
            te sigurnost poslovanja.
          </p>
        </div>

        <div
          class="flex items-center justify-center mt-4 md:mt-8 xl:mt-18 w-3/5 m-auto"
        >
          <figure class="flex justify-center mr-10 relative" v-scroll-reveal>
            <img
              class="w-full"
              src="/img/logos/supranet-iso9001-bw.png"
              alt="iso9001"
            />
            <img
              src="/img/logos/supranet-iso9001.png"
              alt="iso9001"
              class="transition absolute inset-0 opacity-0 hover:opacity-100"
            />
          </figure>
          <figure class="flex justify-center mr-10 relative" v-scroll-reveal>
            <img
              class="w-full"
              src="/img/logos/supranet-iso27001-bw.png"
              alt="iso27001"
            />
            <img
              src="/img/logos/supranet-iso27001.png"
              alt="iso27001"
              class="transition absolute inset-0 opacity-0 hover:opacity-100"
            />
          </figure>
          <figure class="flex justify-center relative" v-scroll-reveal>
            <img
              class="w-full"
              src="/img/logos/supranet-myleviton-bw.png"
              alt="myleviton"
            />
            <img
              src="/img/logos/supranet-myleviton.png"
              alt="myleviton"
              class="transition absolute inset-0 opacity-0 hover:opacity-100"
            />
          </figure>
        </div>
      </div>
    </div>

    <div class="section bg-gray-100">
      <div class="container _xl pull-content">
        <figure
          class="bg-cover w-full h-64 md:h-96 xl:h-128 mx-auto max-w-2xl xxl:max-w-3xl fhd:max-w-4xl"
          style="background-image: url('/img/about/about-3.jpg')"
          v-scroll-reveal
        ></figure>
      </div>
    </div>

    <div class="section pt-0 bg-gray-100 text-secondary">
      <div class="container _xl flex flex-col items-center">
        <h2
          class="text-4xl lg:text-5xl xxl:text-6xl mb-8 lg:mb-16"
          v-scroll-reveal
        >
          Prednosti rada u Supra Net-u
        </h2>

        <p
          class="font-light text-center max-w-md mx-auto mb-8 lg:mb-16"
          v-scroll-reveal
        >
          U Supra Net-u mislimo na naše zaposlenike! Zadovoljni zaposlenici
          temelj su našeg uspjeha. Zato im nudimo mnoge pogodnosti. Pridruži se
          našem timu i iskoristi najbolje uvjete za svoju buduću karijeru.
        </p>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-2 w-full mb-8 lg:mb-16">
          <div
            v-for="(benefit, i) in benefits"
            :key="`benefit-${i}`"
            class="pt-16 pb-5 px-5 bg-white flex flex-col items-center"
          >
            <img class="max-w-80px" :src="benefit.icon" :alt="benefit.name" />

            <span class="block text-center mt-16 text-xl font-bold">{{ benefit.name }}</span>
            <span v-if="benefit.description" class="text-xl text-center font-light">{{ benefit.description }}</span>
          </div>
        </div>

        <a
          href="https://storm-grupa.talentlyft.com/supra-net#home"
          target="_blank"
          class="inline-block text-secondary whitespace-no-wrap hover:text-primary font-bold italic border-t-10 border-primary pt-4 px-2 mx-auto"
          v-scroll-reveal
          >Otvorene pozicije</a
        >

        <h2
          class="text-4xl lg:text-5xl xxl:text-6xl my-8 lg:my-16"
          v-scroll-reveal
        >
          Članica STORM Grupe
        </h2>

        <p class="font-light text-center max-w-md mx-auto" v-scroll-reveal>
          Mi smo stručnjaci za najbolja tehnološka rješenja! Sinergijom suradnje
          i razmjene znanja među tvrtkama članicama Grupe nastavljamo biti
          pouzdan partner regionalnog gospodarstva, uz neprestano ulaganje u
          edukaciju zaposlenih i razvoj inovativnih
          informacijsko-komunikacijskih rješenja.
        </p>

        <figure class="flex justify-center my-8 lg:my-16" v-scroll-reveal>
          <img
            src="/svg/logos/storm-grupa-c.svg"
            class="w-32"
            alt="STORM Grupa"
          />
        </figure>

        <a
          href="https://www.stormgrupa.hr"
          target="_blank"
          class="inline-block text-secondary whitespace-no-wrap hover:text-primary font-bold italic border-t-10 border-primary pt-4 px-2 mx-auto"
          v-scroll-reveal
          >STORM Grupa</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from "../partials/AnimatedNumber";

export default {
  components: {
    AnimatedNumber,
  },

  data() {
    return {
      counter1: {
        title: "",
        number: 0,
      },

      counter2: {
        title: "",
        number: 0,
      },

      counter3: {
        title: "",
        number: 0,
      },

      allowCountingFlag: false,

      benefits: [
        {
          name: "Stručna usavršavanja",
          icon: "/svg/about-us/education.svg",
          description: null,
        },
        {
          name: "Financijske pogodnosti",
          icon: "/svg/about-us/financial-benefits.svg",
          description: "(regres, božićnica, jubilarne nagrade i sl.)",
        },
        {
          name: "Subvencije vrtića",
          icon: "/svg/about-us/kindergarden.svg",
          description: null,
        },
        {
          name: "Rođendanski pokloni",
          icon: "/svg/about-us/birthday.svg",
          description: null,
        },
        {
          name: "Pokloni povodom rođenja djeteta",
          icon: "/svg/about-us/kids.svg",
          description: null,
        },
        {
          name: "Božićni pokloni i predstava za klince",
          icon: "/svg/about-us/gifts.svg",
          description: null,
        },
        {
          name: "Godišnji odmor u trajanju od 22 dana",
          icon: "/svg/about-us/holiday.svg",
          description: null,
        },
        {
          name: "Subvencija MultiSport kartice",
          icon: "/svg/about-us/multisport.svg",
          description: null,
        },
        {
          name: "Dodatno zdravstveno osiguranje",
          icon: "/svg/about-us/health-insurance.svg",
          description: null,
        },
        {
          name: "Dodatno plaćeni slobodni dani",
          icon: "/svg/about-us/free-days.svg",
          description: "(darivanje krvi, prvi dan škole 1.raz.)",
        },
        {
          name: "Subvencije za mobilne uređaje",
          icon: "/svg/about-us/smartphone.svg",
          description: null,
        },
        {
          name: "Team building",
          icon: "/svg/about-us/teambuilding.svg",
          description: null,
        },
      ],
    };
  },

  mounted() {
    this.counter1 = {
      title: "godina uspješnog poslovanja",
      number: 20,
    };
    this.counter2 = {
      title: "zadovoljnih korisnika",
      number: 1000,
    };
    this.counter3 = {
      title: "odrađenih projekata",
      number: 1500,
    };
  },

  methods: {
    allowCounting() {
      this.allowCountingFlag = true;
    },
    resetCounter() {
      this.allowCountingFlag = false;
    },
  },

  metaInfo: {
    title: "O nama",
    meta: [
      {
        vmid: "og:image",
        property: "og:image",
        content: "https://www.supranet.hr/img/about/supranet-onama-cover.jpg",
      },
    ],
  },
};
</script>
